<ion-header>
  <ion-toolbar>
    <ion-title>Enter Password</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding">
    
      <ion-item>
        <ion-label position="floating">Password</ion-label>
        <ion-input type="password" [(ngModel)]="password" name="password" required></ion-input>
      </ion-item>

      <ion-button
      (click)="checkPassword()"
        expand="block"
        type="submit"
        [disabled]="!password"
        class="ion-margin-top"
      >
        Submit
      </ion-button>
  </div>
</ion-content>
